var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPerson = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  "data-coloringtype": "fill",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.9,
  d: "M12 2.25a5.75 5.75 0 0 1 3.12 10.578 8.7 8.7 0 0 1 3.068 1.985A8.75 8.75 0 0 1 20.75 21v.75h-1.5V21a7.251 7.251 0 1 0-14.5 0v.75h-1.5V21a8.744 8.744 0 0 1 5.629-8.172A5.75 5.75 0 0 1 12 2.25m0 1.5a4.25 4.25 0 1 0 0 8.5 4.25 4.25 0 0 0 0-8.5"
})));
export default SvgPerson;